<template>
    <section class="module-footer-links">
        <div class="columns">
            <div class="column" v-for="(elem, index) in footerLinks" :key="index">
                <div class="footer__link-title" v-if="elem.title">
                    <h5>{{ elem.title }}</h5>
                </div>
                <div class="footer__link-title footer__link-empty" v-else>
                    <span>&nbsp;</span>
                </div>
                <a :href="item.url" class="footer__link" v-for="(item, index) in elem.items" :key="index">{{ item.title }}</a>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "ModuleFooterLinks", 
    computed: {
        footerLinks() {
            return this.$store.getters.getFooterLinks;
        }
    },
    methods: {
        getFooterLinks() {
            this.$store.dispatch("getFooterLinks");
        },
    },
    mounted() {
        this.getFooterLinks();
    }
};
</script>
